<script lang="ts" setup>
import FieldText from '@/components/shared/Fields/FieldText.vue'
import Icon from '@/components/shared/Icon.vue'
import { getThemeSettings } from '@/lib'
import { useForm } from 'vee-validate'
import { watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import LayoutHeaderProfile from './LayoutHeaderProfile.vue'

defineProps<{ visible: boolean }>()

defineEmits<{
  toggleSidebar: []
  search: [{ term: string; timestamp: number }]
}>()

const { showLogin } = getThemeSettings()

const route = useRoute()
const router = useRouter()

const { handleSubmit, setValues } = useForm({
  initialValues: {
    search: '',
  },
})

const onSubmit = handleSubmit((values) => {
  const searchTerm = values.search
  const url = searchTerm ? `/search?term=${searchTerm}&ts=${Date.now()}` : '/search'
  if (route.path === '/search') router.replace(url)
  else router.push(url)
})

function handleClear() {
  setValues({ search: '' })
  const url = `/search?ts=${Date.now()}`
  if (route.path === '/search') router.replace(url)
  else router.push(url)
}

watch(
  route,
  () => {
    const queryParams = route.query
    setValues({ search: queryParams.term ? queryParams.term?.toString() : '' })
  },
  { immediate: true },
)
</script>

<template>
  <header
    class="bg-white dark:bg-gray-900 w-full h-[60px] shrink-0 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between gap-x-6 lg:gap-x-0 shadow dark:shadow-gray-900"
  >
    <!-- Toggle Button -->
    <div
      class="flex gap-x-4 items-center pl-4 sm:pl-6"
      :class="visible ? 'lg:w-[var(--sidebar-width)]' : 'w-auto'"
    >
      <button
        type="button"
        class="flex justify-center items-center w-7 h-7 rounded border border-transparent transition-colors default-focus hover:bg-gray-50 active:bg-gray-100 hover:border-gray-200 dark:hover:bg-gray-800 dark:active:bg-gray-700 dark:hover:border-gray-700"
        @click="$emit('toggleSidebar')"
      >
        <Icon variant="menu" class="w-6 h-6 text-gray-900 dark:text-gray-100" />
      </button>
      <!-- TODO: Re-add when needed -->
      <!-- <LayoutHeaderQuickLinks /> -->
    </div>
    <!-- Search Bar -->
    <div class="flex relative flex-1 gap-x-4 justify-center">
      <form class="w-full max-w-xl shrink-0 md:pr-0" @submit="onSubmit">
        <FieldText
          :show-clear="true"
          :show-label="false"
          :validate="false"
          name="search"
          placeholder="Search identities..."
          prefix-icon="search"
          type="text"
          @clear="handleClear"
        />
      </form>
    </div>

    <!-- Dropdown -->
    <div class="pr-4 sm:pr-6">
      <LayoutHeaderProfile v-if="!showLogin" />
    </div>
  </header>
</template>
